module.exports = __webpack_public_path__ + "static/media/mastercard.f7ac102f.svg";